__turbopack_context__.v({
  "chevron": "LinkWithChevron-module-scss-module__UrLXxq__chevron",
  "linkWithChevron": "LinkWithChevron-module-scss-module__UrLXxq__linkWithChevron",
});
